import type { IShopifyPageAssigned, IShopifyPageAssignedResponse } from '~/modules/shopify/types';
import type { ITemplateAssignedType } from '~/types/template';

import { processAssetUnassigned } from '~/modules/campaign';
import { useAssignedStore } from '~/stores/assigned';
import { useAssetsStore } from '~/stores/assets';
import { useCallback, useMemo } from 'react';

interface FetchTemplateUnassignedProps {
  templateAssigned?: IShopifyPageAssignedResponse;
  activePageType: ITemplateAssignedType;
}
export const useTemplateUnassigned = () => {
  const getUnassignedByType = useAssignedStore((state) => state.getUnassignedByType);
  const setUnassignedByType = useAssignedStore((state) => state.setUnassignedByType);
  const dataAssets = useAssetsStore((state) => state.getAssets());
  const assets = useMemo(() => dataAssets, [JSON.stringify(dataAssets)]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchTemplateUnassigned = useCallback(
    ({ templateAssigned, activePageType }: FetchTemplateUnassignedProps): IShopifyPageAssigned => {
      const unassigned = getUnassignedByType(activePageType);
      if (unassigned) return unassigned;

      const shopifyAssigned: IShopifyPageAssigned = { total: 0, url: '', data: [] };
      if (!assets || !templateAssigned) return shopifyAssigned;

      const gatherAllAssets = [
        ...assets.templateGPV7,
        ...assets.templateGPV6,
        ...assets.templateShopify,
      ];

      const totalUnassigned = processAssetUnassigned(templateAssigned || {}, gatherAllAssets);
      setUnassignedByType(activePageType, totalUnassigned);
      return totalUnassigned;
    },
    [assets, getUnassignedByType, setUnassignedByType],
  );

  return {
    fetchTemplateUnassigned,
  };
};
